import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-4 text-sm"
}
const _hoisted_2 = {
  key: 1,
  class: "my-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "text-center mt-6" }

import { required, email } from '@vuelidate/validators';
import {
	useForm,
	UiForm,
	UiInput,
	UiButton,
	UiLink
} from '@/ui-kit';
import AuthContainer from '../../components/AuthContainer.vue';
import { authService } from '@/account/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  setup(__props) {

const { formData, onSubmit, loading, success } = useForm(
	{
		email: ''
	},
	{
		email: {
			required,
			email
		}
	}
);

const submit = onSubmit(authService.resetPassword);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthContainer, {
    title: "Welcome.",
    cardTitle: 
			_unref(success) ? 'Success' : 'Reset your password'
		
  }, {
    default: _withCtx(() => [
      (!_unref(success))
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Enter your email address below and we'll send you an email with instructions to reset your password. "))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(" We have emailed your password reset link! "),
            _hoisted_3,
            _createTextVNode("Follow instructions provided in that email in order to reset your password. ")
          ])),
      (!_unref(success))
        ? (_openBlock(), _createBlock(_unref(UiForm), {
            key: 2,
            onSubmit: _unref(submit)
          }, {
            buttons: _withCtx(() => [
              _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                default: _withCtx(() => [
                  _createTextVNode("Send")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(UiInput), {
                label: "Email",
                name: "email",
                type: "email",
                disabled: _unref(loading),
                modelValue: _unref(formData).email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).email) = $event))
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(UiLink), {
          size: "lg",
          to: { name: 'Login' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("Return to sign-in")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["cardTitle"]))
}
}

})